import { render, staticRenderFns } from "./SearchAnything.vue?vue&type=template&id=6b33fa74&scoped=true"
import script from "./SearchAnything.vue?vue&type=script&lang=ts"
export * from "./SearchAnything.vue?vue&type=script&lang=ts"
import style0 from "./SearchAnything.vue?vue&type=style&index=0&id=6b33fa74&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b33fa74",
  null
  
)

export default component.exports